import React from 'react';
import {EVENT_ERROR, EVENT_RESET} from "./Events";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };

        this.onError = this.onError.bind(this);
        this.reset = this.reset.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);
    }

    componentDidMount() {
        document.addEventListener(EVENT_ERROR, this.onError);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo
        })
    }

    onError(event) {
        this.setState({
            hasError: true,
            error: event.detail.error,
            errorInfo: event.detail.errorInfo
        });
    }

    reset() {
        this.setState({
            hasError: false,
            error: null,
            errorInfo: null
        });

        let event = new CustomEvent(EVENT_RESET);
        document.dispatchEvent(event);
    }

    getErrorMessage() {
        if (this.state.errorInfo.isAxiosError && this.state.errorInfo.response.status === 429) {
            return (
                <>
                    <h2 className="mb-2 headline">Sie haben die maximale Anzahl an Anfragen pro Tag erreicht.</h2>
                    <h4 className="mb-2 sub-headline">Bitte versuchen Sie es später erneut.</h4>
                </>
            );
        }

        return (
            <>
                <h2 className="mb-2 headline">Es ist ein unerwarteter Fehler aufgetreten.</h2>
                <h4 className="mb-2 sub-headline">Bitte versuchen Sie es erneut.</h4>
            </>
        );
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className='bg-blue-dark font-sans'>
                    <div className='container mx-auto px-3 text-center'>
                        <div className="py-24">
                            <div className="mb-8">
                                {this.getErrorMessage()}
                            </div>
                            <button
                                onClick={this.reset}
                                type="button"
                                className="button px-3 py-2 rounded-l-sm md:rounded-l-none rounded-r-sm disabled:opacity-95"
                            >
                                Suche neustarten
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}
